import { render, staticRenderFns } from "./info-line.vue?vue&type=template&id=2dc09a01&scoped=true&"
import script from "./info-line.vue?vue&type=script&lang=js&"
export * from "./info-line.vue?vue&type=script&lang=js&"
import style0 from "./info-line.vue?vue&type=style&index=0&id=2dc09a01&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.9.7_eeqz4xtr3chsfpwu4zsrvzqhvy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc09a01",
  null
  
)

export default component.exports